/**
 * Performs a scroll lock
 * Relies on the css class `.no-scroll`
 */
export const lockScroll = (className) => {
  const scrollbarWidth = (window.innerWidth - document.body.clientWidth);
  const scrollingElement = document.scrollingElement || document.body;

  scrollingElement.dataset.scroll = window.scrollY;
  scrollingElement.style.setProperty('--scroll-bar-width', `${scrollbarWidth}px`);
  scrollingElement.classList.add('no-scroll');
  className && scrollingElement.classList.add(className);
}

/**
 * Release scroll lock
 * Relies on the css class `.no-scroll`
 */
export const releaseScroll = (className) => {
  const scrollingElement = document.scrollingElement || document.body;
  
  scrollingElement.classList.remove('no-scroll');
  className && scrollingElement.classList.remove(className);

  scrollingElement.style.removeProperty(`--scroll-bar-width`);
  if (scrollingElement.hasAttribute('data-scroll')) {
    window.scrollTo(0, scrollingElement.dataset.scroll);
  }
  scrollingElement.removeAttribute('data-scroll');
}
